module.exports = __webpack_public_path__ + "img/n.0f00c758.jpg";